import commonService from "./common-service";

class DeliveryService {
  async getRecords(rxcode) {
    try {
      const response = await commonService.getFromServer(
        "Remote/DeliveryRecons?rxf_num=" + rxcode,
        {}
      );
      if (response?.length) {
        return response;
      } else {
        throw new Error("No records found.");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async scanRecord(params) {
    try {
     const response =  await commonService.postToServer("Remote/DeliveryRecons", params);
     return response;
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new DeliveryService();
